<template>
  <el-tooltip effect="dark" content="格式刷" placement="bottom" :open-delay="1000">
    <div
      class="adsorb formatBrush"
      :class="{
        'prohibited' : formatBrush.step === 0,
        'available'  : formatBrush.step === 1,
        'carryOutble': formatBrush.step === 2,
      }"
      @click="formatBrushFS()"
      @dblclick="formatBrushFrequency()"
    >
      <i
        class="icon-editor-brush"
        :class="{active: formatBrush.step === 2, disabled: formatBrush.step === 0}"
      ></i>
    </div>
  </el-tooltip>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      formatBrush: {
        step: 0, // 0--禁止， 1--可用，2--已经缓存数据
        data: null,
        frequency: false, // 判断多次或者单次
      },
    };
  },
  computed: {
    ...mapGetters(["TOOL"]),
  },
  watch: {
    "TOOL.selectedSprite": {
      handler(val, oldval) {
        if (val.length == 1 && this.formatBrush.step == 0) {
          this.formatBrush.step = 1;
        }
        this.formatBrushSprite();
      },
    },
  },
  mounted() {
    this.$bus.on("window_click", () => {
      if (this.TOOL.selectedSprite.length != 1) this.clearBrush();
    });
    this.$bus.on("scene_click", () => {
      if (this.formatBrush.step == 1) this.clearBrush();
    });
  },
  methods: {
    clearBrush() {
      this.formatBrush.data = null;
      this.formatBrush.step = 0;
      this.formatBrush.frequency = false;
      this.$bus.emit("format-brush-status", { status: "clear" });
    },
    formatBrushFS() {
      // 点击保存数据
      if (this.formatBrush.step == 1 && !this.formatBrush.data) {
        this.formatBrush.data = Object.assign(
          {},
          this.TOOL.selectedSprite[0].toJson()
        );
        this.formatBrush.step = 2;
        this.$bus.emit("format-brush-status", { status: "push" });
        this.$analysis({
          category: "format_brush",
          action: "click_single_use",
          label: "格式刷_单击",
        });
      }
    },
    formatBrushSprite() {
      // 点击刷新元素
      if (this.TOOL.selectedSprite.length == 1 && this.formatBrush.step == 2) {
        let data = this.formatBrush.data,
          sprite = this.TOOL.selectedSprite[0],
          content = {},
          past = {};
        let effect = sprite.effect;

        // outward基本属性
        content.outward = {
          rotate: data.outward.rotation,
          flip: data.outward.isFlipped,
          opacity: data.outward.opacity,
        };
        past.outward = {
          rotate: sprite.rotate,
          flip: sprite.flip,
          opacity: sprite.opacity,
        };

        // 获取动画对象
        let enterEffect = Object.assign({}, data.enterEffect),
          stayEffect = data.stayEffect,
          exitEffect = data.exitEffect,
          exitHand = exitEffect.hand,
          hand = enterEffect.hand;

        let attachAnim = stayEffect.attachAnim
          ? stayEffect.attachAnim[0]
          : null;
        let stayDuration =
          (effect.exitAnim.start - effect.entranceAnim.end) / 1000;

        if (data.type !== sprite.type) {
          if (this.isSpecialEffect(enterEffect.type)) {
            enterEffect.type = "FadeIn";
          }
        }
        if (
          data.enterEffect.type === "Draw" &&
          (sprite.type === "Svg" || sprite.type === "Image")
        ) {
          enterEffect.type = "Draw";
        }

        content.effect = {
          // 入场动画
          code: enterEffect.type,
          direction: this.getSmearDire(
            enterEffect.direction,
            this.TOOL.productionPlatform,
            enterEffect.type
          ),
          easing: this.getEasingName(enterEffect.easing),
          drawingDuration:
            enterEffect.drawDuration > stayDuration
              ? stayDuration * 1000
              : enterEffect.drawDuration * 1000,
          entranceAnim: {
            hand: this.getHand(data, sprite),
            writehand: this.getHand(data, sprite),
          },
          // 出场动画
          exitAnim: {
            direction: exitEffect.direction,
            type: exitEffect.type,
            easing: this.getEasingName(exitEffect.easing),
            hand: exitHand
              ? exitHand.url
                ? {
                    x: exitHand.anchorPointX,
                    y: exitHand.anchorPointY,
                    url: this.handleAssetsUrl(exitHand.url),
                  }
                : null
              : null,
          },
          // 停留动画
          stayAnim: attachAnim
            ? Object.assign(
                { type: attachAnim.type },
                JSON.parse(attachAnim.data)
              )
            : null,
          // 路径动画
          pathAnim: attachAnim ? null : {},
        };

        if (stayEffect.animationGraphs && stayEffect.animationGraphs[0]) {
          content.effect.stayAnim = Object.assign({}, effect.stayAnim);
        }

        past.effect = {
          code: effect.code,
          easing: effect.easing,
          direction: effect.direction,
          entranceAnim: {
            start: effect.entranceAnim.start,
            end: effect.entranceAnim.end,
            hand: effect.entranceAnim.hand
              ? Object.assign({}, effect.entranceAnim.hand)
              : null,
          },
          stayAnim: $.extend(true, {}, effect.stayAnim),
          exitAnim: {
            type: effect.exitAnim.type,
            easing: effect.exitAnim.easing,
            direction: effect.exitAnim.direction,
            start: effect.exitAnim.start,
            end: effect.exitAnim.end,
            hand: effect.exitAnim.hand
              ? Object.assign({}, effect.exitAnim.hand)
              : null,
          },
          pathAnim: effect.pathAnim.end ? effect.getPathAnim() : null,
        };

        // 文字部分
        if (data.font && sprite.type === "Text") {
          content.text = {
            option: {
              font: Object.assign({}, data.font),
              letterSpacing: data.characterSpacing,
              lineHeight: data.lineSpacing,
            },
            artType: data.artType,
            versionAnyway: data.versionAnyway,
          };
          past.text = {
            option: {
              font: Object.assign({}, sprite.font),
              letterSpacing: sprite.letterSpacing,
              lineHeight: sprite.lineHeight,
            },
            artType: sprite.artType,
            versionAnyway: sprite.versionAnyway,
          };
          sprite.artSetting({ artType: data.artType });
          sprite.setversionAnyway(data.versionAnyway);
          sprite.updateSprite(content.text.option);
        }

        // filter部分
        content.filter = Object.assign({}, data.filter);
        past.filter = Object.assign({}, sprite.filter);

        // border
        content.border = null;
        past.border = null;
        if (sprite.border) {
          past.border = $.extend({}, sprite.border);
          delete past.border.dom;
        }
        if (data.border && sprite.type !== "Text") {
          content.border = Object.assign({}, data.border);
          if (sprite.type === "Lottie") {
            content.border.radius = [0, 0, 0, 0];
          } else {
            content.border.radius = [].concat(data.border.radius);
          }
        }
        sprite.setBorder(content.border);

        // boxShadow
        if (sprite.type !== "Text" && data.boxShadow) {
          content.boxShadow = Object.assign({}, data.boxShadow);
        } else {
          content.boxShadow = null;
        }
        content.dropShadow = data.dropShadow
          ? Object.assign({}, data.dropShadow)
          : null;
        past.boxShadow = sprite.boxShadow
          ? Object.assign({}, sprite.boxShadow)
          : null;
        past.dropShadow = sprite.dropShadow
          ? Object.assign({}, sprite.dropShadow)
          : null;
        sprite.setShadow(content.boxShadow);
        sprite.setShadow(content.dropShadow, "dropShadow");

        // bgColor
        if (sprite.type !== "Text") {
          content.bgColor = data.bgColor;
        } else {
          content.bgColor = "";
        }
        past.bgColor = sprite.bgColor;
        sprite.setBgColor(content.bgColor);

        // svg部分
        if (data.strokeWidth && "strokeWidth" in sprite.option) {
          content.strokeSvg = {
            strokeWidth: data.strokeWidth,
            stroke: data.stroke,
            fill: data.color,
          };
          past.strokeSvg = {
            color: sprite.option.fill || sprite.fill,
            stroke: sprite.option.stroke || sprite.stroke,
            strokeWidth: sprite.option.strokeWidth,
          };
        }

        // 循环播放部分
        if ("isLoop" in data && sprite.setLoop) {
          content.isLoop = data.isLoop;
          content.numberOfLoops = data.numberOfLoops;
          let loop = sprite.getLoop();
          past.isLoop = loop.isLoop;
          past.numberOfLoops = loop.numberOfLoops;
          if (sprite.type === "Video") {
            sprite.setRepeatTimes(content.numberOfLoops);
          } else {
            sprite.setLoop(content.numberOfLoops);
          }
          sprite.setLoop(content.isLoop);
        }

        if (content.strokeSvg) {
          sprite.updateSprite(content.strokeSvg).then(() => {
            sprite.update(content.outward);
          });
        } else {
          sprite.update(content.outward);
        }

        sprite.setFilter(data.filter);
        sprite.updateEffect(content.effect);

        eve("undo_redo", null, {
          type: "formatBrush",
          data: {
            spriteId: sprite.id,
            scenesId: sprite.scenesId,
            scale: this.TOOL.scale,
            reData: past,
            data: content,
          },
        });
        if (!this.formatBrush.frequency) this.clearBrush();
      }
    },
    formatBrushFrequency() {
      if (this.TOOL.selectedSprite.length == 1) {
        this.formatBrush.frequency = true;
        this.$analysis({
          category: "format_brush",
          action: "click_multi_use",
          label: "格式刷_双击",
        });
      }
    },
    getSmearDire(d, p, t) {
      if (/uwp/i.test(p) && /smear/i.test(t)) {
        var map = {
          n: "s",
          e: "w",
          s: "n",
          w: "e",
        };
        return map[d];
      }
      return d;
    },
    getEasingName(num) {
      var map = ["linear", "easeOutExpo", "easeOutQuint"];
      return map[num] || 1;
    },
    getHand(sData, sprite) {
      var drawhand = sData.enterEffect.hand;
      var writehand = sData.enterEffect.writehand;
      var url;
      if (sData.enterEffect.type === "Write") {
        url = (writehand || {}).url;
        if (writehand && writehand.resourceId && url) {
          url = this.handleAssetsUrl(url);
        }
        return writehand && writehand.url
          ? Object.assign({}, writehand, {
              url: url,
            })
          : null;
      }
      return drawhand && drawhand.url
        ? {
            x: drawhand.anchorPointX,
            y: drawhand.anchorPointY,
            url: this.handleAssetsUrl(drawhand.url),
          }
        : null;
    },
    handleAssetsUrl(url) {
      if (!url) return "";
      var reg = /^\//;
      // var qiniuAssetsUrl = 'http://www.laihua.com';
      var qiniuAssetsUrl = "https://resources.laihua.com";

      var reg2 = new RegExp(qiniuAssetsUrl + "/", "g");
      url = url.replace(reg2, "");
      // var qiniuAssetsUrl = '';
      if (!reg.test(url)) {
        return qiniuAssetsUrl + "/" + url;
      } else {
        return qiniuAssetsUrl + url;
      }
    },
    _scaleArr: function (arr, scale) {
      if (!arr) return;
      for (var i = 0; i < arr.length; i++) {
        arr[i] *= scale;
      }
      return arr;
    },
    unhandleAssetsUrl(url) {
      return url ? url.replace(/https:\/\/resources.laihua.com(\/)?/, "") : "";
    },
    isSpecialEffect(code) {
      return /^(?:appear|type|bounce|roll|draw|hand|write)$/i.test("" + code);
    },
  },
};
</script>

<style lang="scss" scoped>
.formatBrush {
  &.prohibited {
    background-color: #fafaff;
    cursor: not-allowed;
  }
  &.carryOutble {
    background-color: #9692a9;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/tool/editorBtn/formatBrush.vue